import classNames from "classnames";
import { useState } from "react";
import { useTranslations } from "../../hooks/useTranslations";
import { App } from "../../types";
import SVGBullet from "../icons/Bullet";
import Button from "./Button";
import styles from "./Services.module.css";

interface Props {
  items: ServiceItemProps[];
}

const Services = ({ items }: Props) => (
  <div className={styles.services}>
    {items.map((item) => (
      <ServiceItem key={item.id} {...item} />
    ))}
  </div>
);

type ServiceItemProps = App;

const ServiceItem = ({
  name,
  department,
  description,
  isVisible,
  publishedAt,
  onNavigate,
}: ServiceItemProps) => {
  const { i18n } = useTranslations();
  const [isLoading, setLoading] = useState(false);

  if (!isVisible) return null;

  const today = new Date();
  const twoMonthsAgo = new Date();
  twoMonthsAgo.setMonth(today.getMonth() - 2);

  const isRecentlyPublished = publishedAt && publishedAt >= twoMonthsAgo;

  return (
    <article className={classNames(styles.service, styles[department])}>
      <span className={styles.department}>
        <SVGBullet
          className={classNames(styles.departmentIcon, styles[department])}
        />
        {i18n.departments[department].title}
      </span>
      {isRecentlyPublished && (
        <span className={styles.new}>{i18n.services.new}</span>
      )}
      <h3 className={styles.heading}>{name}</h3>
      <div className={styles.description}>{description}</div>
      <div className={styles.button}>
        <a
          tabIndex={-1}
          onClick={async (e) => {
            e.preventDefault();
            setLoading(true);
            const result = onNavigate();
            if (result instanceof Promise) {
              await result;
            }
            setLoading(false);
          }}
        >
          <Button type="primary" isLoading={isLoading}>
            {i18n.services.open}
          </Button>
        </a>
      </div>
    </article>
  );
};

export default Services;
